import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReference: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconReference"><Path fillRule="evenodd" clipRule="evenodd" d="M20 22H6.75C5.23122 22 4 20.7688 4 19.25V5C4 3.34315 5.34315 2 7 2H20V22ZM6.75 18.5C6.33579 18.5 6 18.8358 6 19.25C6 19.6642 6.33579 20 6.75 20H18V18.5H6.75ZM6.75 15C6.33579 15 6 15.3358 6 15.75C6 16.1642 6.33579 16.5 6.75 16.5H18V15H6.75ZM8 6V8H16V6H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReference;
